import { combineReducers, configureStore } from '@reduxjs/toolkit'

import { dashboardReducer } from 'features/dashboard'
import { simulatorReducer } from 'features/simulator'

const rootReducer = combineReducers({
  dashboard: dashboardReducer,
  simulator: simulatorReducer,
})

export const store = configureStore({
  reducer: rootReducer,
})

export type AppDispatch = typeof store.dispatch
export type AppRootState = ReturnType<typeof store.getState>
